// libs
import React from 'react';

// services
import AuthService from "../../../../../services/AuthService";

const ConnectionDetails = (props) => {
    const {
        member
    } = props;

    // if (!AuthService.isAdmin()) {
    //     if (AuthService.getAdminType() != 3) {
    //         return null;
    //     }
    // }

    return (
        AuthService.can('connection details') &&
        <div className="margin--30--bot">
            <h3 className="sub-title margin--10--bot">Connection Details</h3>
            <ul className="list--box list--info">
                <li>
                    <p className="list--info__label">
                        <strong className="text--caps text--color">Futura ID </strong>
                        {member.futuraCustomerId}
                    </p>
                    <p className="list--info__label">
                        <strong className="text--caps text--color">GiveX ID </strong>
                        {member.givexCustomerId}
                    </p>
                    <p className="list--info__label">
                        <strong className="text--caps text--color">ISO-Serial </strong>
                        {member.isoSerialNumber}
                    </p>
                </li>
            </ul>
        </div>
    );
};

export default ConnectionDetails;
